import type { ReactFCC } from 'types/react';

import { ownTemplatesEffects, ownTemplatesEvents, ownTemplatesStores } from 'stores/ownTemplates';
import { leaveBuilderModalStore, templateModalStore } from 'stores/modals';
import { questionnaireEvents } from 'stores/builder/questionnaire';
import { Button } from 'ui-kit/components/buttons/Button';
import { blockEvents } from 'stores/builder/block';
import { TEMPLATES_LINK } from 'constants/routes';
import { Modal } from 'ui-kit/components/Modal';
import { useNavigate } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useCallback } from 'react';

import { AreYouSureIcon } from '../AreYouSureModal/static_assets';
import { ButtonsContainer, BodyContainer, Text } from './styles';

export const LeaveBuilderModal: ReactFCC = () => {
    const { closeModal, modal } = leaveBuilderModalStore;
    const [_, { isUpdatingTemplate, documentName, config }] = useUnit(modal);
    const ownTemplate = useUnit(ownTemplatesStores.template);
    const navigate = useNavigate();

    const goBackToDashboardTemplates = () => {
        navigate(TEMPLATES_LINK);
        closeModal();

        blockEvents.resetBlocksEvent();
        questionnaireEvents.resetQuestionnaireEvent();
        ownTemplatesEvents.resetTemplate();
    };

    const handleSaveTemplate = useCallback(async () => {
        if (ownTemplate) {
            const data = {
                templateName: ownTemplate?.templateName,
                templateCategory: 'Hiring',
                templateType: 'Contract',
                templateConfig: config,
                documentName
            };

            await ownTemplatesEffects.updateTemplate({ id: ownTemplate?.id, data });
            closeModal();
        }
    }, [closeModal, config, documentName, ownTemplate]);

    const handleCreateTemplate = () => {
        closeModal();

        templateModalStore.openModal({ documentName, config });
    };

    return (
        <Modal title={'Unsaved changes'} onClose={closeModal} visible>
            <BodyContainer>
                <AreYouSureIcon />
                <Text>
                    You are about to leave this template without saving. All changes will be lost. Do you really want to
                    discard changes?
                </Text>
            </BodyContainer>
            <ButtonsContainer>
                <Button onClick={goBackToDashboardTemplates} variant="secondary">
                    Discard changes
                </Button>
                <Button onClick={isUpdatingTemplate ? handleSaveTemplate : handleCreateTemplate} variant="primary">
                    Save template
                </Button>
            </ButtonsContainer>
        </Modal>
    );
};
